export const SET_MODEL_DETAILS = "SET_MODEL_DETAILS";
export const SET_TABLE = "SET_TABLE"; // used for initially setting the data structure with data retrieved from the server
export const SET_WEIGHT = "SET_WEIGHT";
export const SET_LOCKED = "SET_LOCKED";
export const SET_ALL_LOCKED = "SET_ALL_LOCKED";
export const ADD_CUSTOM_ASSET_CLASS_TO_LIST = "ADD_CUSTOM_ASSET_CLASS_TO_LIST";
export const UPDATE_CUSTOM_ASSET_CLASS = "UPDATE_CUSTOM_ASSET_CLASS";
export const ADD_ASSET_CLASS_TO_MODEL = "ADD_ASSET_CLASS_TO_MODEL";
export const ADD_SLEEVE_TO_ASSET_CLASS_IN_MODEL =
  "ADD_SLEEVE_TO_ASSET_CLASS_IN_MODEL";
export const ADD_SECURITY_TO_ASSET_CLASS_IN_MODEL =
  "ADD_SECURITY_TO_ASSET_CLASS_IN_MODEL";
export const REASSIGN_SLEEVE_OR_SECURITY_IN_MODEL =
  "REASSIGN_SLEEVE_OR_SECURITY_IN_MODEL";
export const REMOVE_ASSET_CLASS_OR_SLEEVE_OR_SECURITY_FROM_MODEL =
  "REMOVE_ASSET_CLASS_OR_SLEEVE_OR_SECURITY_FROM_MODEL";
export const SET_SLEEVES_AND_SECURITIES = "SET_SLEEVES_AND_SECURITIES";
export const SORT_ASSET_CLASSES_ASC = "SORT_ASSET_CLASSES_ASC";
export const SORT_ASSET_CLASS_WEIGHTS_DESC = "SORT_ASSET_CLASS_WEIGHTS_DESC";
export const SET_SLEEVE_NAME = "SET_SLEEVE_NAME";
export const EXPAND_COLLAPSE_CHILDREN = "EXPAND_COLLAPSE_CHILDREN";
export const SET_DEFAULT_ASSET_CLASSES_AND_THEIR_CATEGORIES =
  "SET_DEFAULT_ASSET_CLASSES_AND_THEIR_CATEGORIES";
